import logo from '../assets/logo.png';
import heroClienti from '../assets/heroClienti.webp';
import mozzarella from '../assets/mozzarella.webp';
import frantoio from '../assets/frantoio.webp';
import panificio from '../assets/panificio.webp';
import heroproduttori from '../assets/heroproduttori.webp';
import camioncino from '../assets/camioncino.webp';
import heroCandidatura from '../assets/heroCandidatura.webp';

export { logo, heroClienti, camioncino };

/** Fallback locale per slug categoria (se API senza foto) */
export const CATEGORIA_MEDIA = {
  'mozzarella-di-bufala': mozzarella,
  'olio-extravergine-di-oliva': frantoio,
  'pasta-di-grano-duro': panificio,
  'salumi-artigianali': heroproduttori,
  'pomodoro-san-marzano-dop': frantoio,
  'gorgonzola-dop': mozzarella,
  'pistacchi-di-bronte': heroproduttori,
  'pecorino-sardo': mozzarella,
  'prosciutto-di-parma': heroproduttori,
  'pesto-genovese-dop': frantoio,
};

export function getCategoriaImage(categoria, baseUrl) {
  if (categoria?.foto?.[0]?.path) {
    return `${baseUrl}/api/file/${categoria.foto[0].path}`;
  }
  return CATEGORIA_MEDIA[categoria?.slug] || heroCandidatura;
}

export function getCategoriaGallery(categoria, baseUrl) {
  const api = (categoria?.foto || []).map((f) => `${baseUrl}/api/file/${f.path}`);
  if (api.length) return api;
  const local = CATEGORIA_MEDIA[categoria?.slug];
  return local ? [local, heroClienti] : [heroCandidatura];
}
